import { getAthleteAxiosInstance } from './authentication-service';

export const GetAthleteToken = async (athleteCred: any): Promise<any> => {
  const axiosInstance = await getAthleteAxiosInstance();
  if (!axiosInstance) {
    throw new Error('Failed to create Axios instance');
  }
  return axiosInstance.post('athlete/token/v1', {
    assertion: convertStringToBase64(
      `${athleteCred.country};${athleteCred.storeNumber};${athleteCred.employeeId}:${athleteCred.password}`,
    ),
    grant_type: 'nike:athlete:ID',
    client_id: 'nike.athlete.platform',
  });
};

const convertStringToBase64 = (str: string): string => {
  return btoa(str);
};
